import axios from "axios";

const uploadSignedImage = async (file) => {
  // CLOUDINARY START
  // Step 1: Get signature and timestamp from backend
  // const res = await axios.get(`${process.env.REACT_APP_API_URL}/cloudinary/`);
  // const { timestamp, signature, api_key, cloud_name } = await res.data;

  // // Step 2: Upload with signature
  // const formData = new FormData();
  // formData.append("file", file);
  // formData.append("api_key", api_key);
  // formData.append("timestamp", timestamp);
  // formData.append("signature", signature);

  // const uploadRes = await fetch(
  //   `https://api.cloudinary.com/v1_1/${cloud_name}/image/upload`,
  //   {
  //     method: "POST",
  //     body: formData,
  //   }
  // );

  // const data = await uploadRes.json();
  // return data.secure_url;
  // CLOUDINARY END

  try {
    const formData = new FormData();
    formData.append("file", file);

    const response = await axios.post(
      `${process.env.REACT_APP_IMAGE_UPLOAD_API_URL}?api_key=${process.env.REACT_APP_IMAGE_UPLOAD_API_KEY}&generate_public_url=${process.env.REACT_APP_IS_IMAGE_PUBLIC_URL}`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${process.env.REACT_APP_IMAGE_UPLOAD_API_KEY}`,
        },
        maxBodyLength: Infinity,
      }
    );

    return response.data.public_url;
  } catch (error) {
    console.error("Upload error:", error);
    throw error;
  }

};

export default uploadSignedImage;
